export const LogoMark = ({ size = 40, className = "" }) => (
  <img src="/brand/logo-mark.webp" alt="" aria-hidden="true" style={{ height: size, width: "auto" }} className={className} />
);

export const LogoFull = ({ className = "" }) => (
  <img src="/brand/logo-full.webp" alt="Hybrid Health Lab · Lifestyle Training" className={className} data-testid="logo-full" />
);

export const Logo = ({ testid = "brand-logo" }) => (
  <span data-testid={testid} className="flex items-center gap-3">
    <LogoMark />
    <span className="flex flex-col">
      <span className="font-display text-lg font-800 uppercase leading-none tracking-wide text-[#98bfa2]">Hybrid Health Lab</span>
      <span className="mt-0.5 font-mono text-[10px] uppercase tracking-[0.25em] text-[#a3b1aa]">Lifestyle Training</span>
    </span>
  </span>
);
